"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegulatoryDocuments = exports.getFundDocumentTabConfig = exports.getSingleInsightsConfig = exports.getInsightsConfig = exports.getFundDocumentConfig = undefined;

var _ramda = require("ramda");

var _string_utility = require("./string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require("./functional_utility");

var _constants = require("./constants");

var _constants2 = _interopRequireDefault(_constants);

var _url_utility = require("./url_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAG = _constants2.default.getFdTagConstants();
var getFundDocumentConfig = function getFundDocumentConfig(country, role, filter, cmsShare, visibleDataPoints, factsheetUrl) {
  var fundDocumentConfig = {
    INVESTMENT_TRUST: [{
      cardCategory: "Regulatory Documents",
      headerTitle: "Legal documents",
      columnIndex: 0,
      dataTestId: "legal-documents",
      documents: []
    }, {
      cardCategory: "Annual General Meeting",
      headerTitle: "Annual General Meeting and General / Class meeting",
      columnIndex: 0,
      dataTestId: "annual-general-meeting",
      documents: []
    }, {
      cardCategory: "Trust Information",
      headerTitle: "Trust Information",
      columnIndex: 1,
      dataTestId: "trust-information",
      documents: [{
        title: "Factsheet",
        docURL: factsheetUrl
      }]
    }, {
      cardCategory: "Committee Terms of Reference",
      headerTitle: "Committee terms of reference",
      columnIndex: 1,
      dataTestId: "committee-terms-of-reference",
      documents: []
    }, {
      cardCategory: "Research",
      headerTitle: "Research",
      columnIndex: 1,
      dataTestId: "research",
      documents: [],
      disclosureId: "pdpCardResearch"
    }, {
      cardCategory: "Historical Report and Accounts",
      headerTitle: "Reports and accounts",
      columnIndex: 2,
      dataTestId: "reports-and-accounts",
      documents: []
    }, {
      cardCategory: "Conversion details",
      headerTitle: "Conversion details",
      columnIndex: 1,
      dataTestId: "conversion-details",
      documents: []
    }, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_INSIGHTS_CARD', visibleDataPoints) ? {
      cardCategory: "J.P. Morgan Insights",
      headerTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
      columnIndex: 0,
      dataTestId: "insights",
      documents: getInsightsConfig()
    } : {}]
  };
  return fundDocumentConfig[filter];
};

var getFundDocumentTabConfig = function getFundDocumentTabConfig(_ref) {
  var country = _ref.country,
      role = _ref.role,
      language = _ref.language,
      cusip = _ref.cusip,
      cmsShare = _ref.cmsShare,
      gaiaRedirectUrl = _ref.gaiaRedirectUrl,
      hasFundDistribution = _ref.hasFundDistribution,
      isShareclassMoreThanSixMonthsOld = _ref.isShareclassMoreThanSixMonthsOld,
      visibleDataPoints = _ref.visibleDataPoints,
      intl = _ref.intl,
      factsheetUrl = _ref.factsheetUrl,
      kiidUrl = _ref.kiidUrl,
      fundName = _ref.fundName,
      formNMFPLink = _ref.formNMFPLink,
      fundTypeCode = _ref.fundTypeCode,
      esgIntegrationFlag = _ref.esgIntegrationFlag;

  var hkFundDistributionDocs = [];
  var hkFundLiteratureDocsForNonCIFM = [{ documentType: TAG.FACT_SHEET }, { documentType: TAG.APAC_OFFERING_DOCUMENT }, { documentType: TAG.APAC_FINANCIAL_REPORT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: TAG.ANNUAL_REPORT }];

  var hkFundLiteratureDocsForCIFM = [{ documentType: TAG.FACT_SHEET }, { documentType: TAG.HK_FUND_INFORMATION_CHINESE }, { documentType: TAG.APAC_COVERING_DOCUMENT }, { documentType: TAG.SUMMARY_PROSPECTUS }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.HK_PRODUCT_KEY_FACT_STATEMENT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: TAG.ANNUAL_REPORT }];

  var hkFinancialReportDocsForCIFM = [];

  if (country === 'hk') {
    if (hasFundDistribution) {
      hkFundDistributionDocs = [{
        docURL: encodeURI(gaiaRedirectUrl + '/excel?type=fundDistribution' + '&cusip=' + cusip + '&country=' + country + '&role=' + role + '&locale=' + _string_utility2.default.generateLocale()),
        title: _string_utility2.default.renderFormattedLabel('Dividend History (Fund Level)', "pdp-documents-tab-dividend-history-link-label")
      }, {
        docURL: encodeURI(gaiaRedirectUrl + '/excel?type=compositionOfFundDistribution' + '&cusip=' + cusip + '&country=' + country + '&role=' + role + '&locale=' + _string_utility2.default.generateLocale()),
        title: _string_utility2.default.renderFormattedLabel('Composition of the Fund Distribution (Fund Level)', "pdp-documents-tab-composition-of-fund-distribution-history-link-label")
      }];
    }

    if (isShareclassMoreThanSixMonthsOld) {
      hkFinancialReportDocsForCIFM = [{ documentType: TAG.APAC_QUARTERLY_FINANCIAL_REPORT }, { documentType: TAG.SUMMARY_SEMI_ANNUAL_REPORT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: TAG.SUMMARY_ANNUAL_REPORT }, { documentType: TAG.ANNUAL_REPORT }];
    }
  }

  var isESGTabEnabled = (0, _functional_utility.isEmeaRegion)(country) && esgIntegrationFlag && !(0, _ramda.isNil)(visibleDataPoints) && !(0, _ramda.includes)('HIDE_ESG_INFORMATION_TAB', visibleDataPoints);
  var esgInformationCard = isESGTabEnabled ? {} : {
    cardTitle: _string_utility2.default.renderFormattedLabel('ESG Information', 'pdp-documents-esg-information-label'),
    cardTitleId: 'esgInformationDocuments',
    dataTest: 'esg-information-documents',
    documents: [{ documentType: 'ESG Information' }]
  };

  var emeaInstitutionalFundTypes = ["FT_LUX_FUND", "FT_LIQUIDITY_FUND", "N_ETF", "FT_OEICS", "FT_ELTIF"];
  var fundDocumentTabConfig = {
    hk: {
      adv: [{
        fundTypes: ["HK_UNIT_TRUST_PROVIDENT", "HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND", "HK_UNIT_TRUST_SAR", "MAURITIUS_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: hkFundLiteratureDocsForNonCIFM
      }, {
        fundTypes: ["HK_UNIT_TRUST_PROVIDENT", "HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND", "HK_UNIT_TRUST_SAR", "MAURITIUS_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Fund Distribution Record", "pdp-documents-tab-fund-distribution-record-card-label"),
        cardTitleId: 'fundDistributionRecord',
        dataTest: 'fund-distribution-record',
        documents: hkFundDistributionDocs
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: hkFundLiteratureDocsForCIFM
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Financial Report", "pdp-documents-tab-financial-report-card-label"),
        cardTitleId: 'financialReport',
        dataTest: 'financial-report',
        documents: hkFinancialReportDocsForCIFM
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Fund Distribution Record", "pdp-documents-tab-fund-distribution-record-card-label"),
        cardTitleId: 'fundDistributionRecord',
        dataTest: 'fund-distribution-record',
        documents: [{ documentType: 'Income Distribution Rates' }]
      }],
      per: [{
        fundTypes: ["HK_UNIT_TRUST_PROVIDENT", "HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND", "HK_UNIT_TRUST_SAR", "MAURITIUS_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: hkFundLiteratureDocsForNonCIFM
      }, {
        fundTypes: ["HK_UNIT_TRUST_PROVIDENT", "HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND", "HK_UNIT_TRUST_SAR", "MAURITIUS_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Fund Distribution Record", "pdp-documents-tab-fund-distribution-record-card-label"),
        cardTitleId: 'fundDistributionRecord',
        dataTest: 'fund-distribution-record',
        documents: hkFundDistributionDocs
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: hkFundLiteratureDocsForCIFM
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Financial Report", "pdp-documents-tab-financial-report-card-label"),
        cardTitleId: 'financialReport',
        dataTest: 'financial-report',
        documents: hkFinancialReportDocsForCIFM
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Fund Distribution Record", "pdp-documents-tab-fund-distribution-record-card-label"),
        cardTitleId: 'fundDistributionRecord',
        dataTest: 'fund-distribution-record',
        documents: [{ documentType: 'Income Distribution Rates' }]
      }],
      preview: [{
        fundTypes: ["HK_UNIT_TRUST_PROVIDENT", "HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND", "HK_UNIT_TRUST_SAR", "MAURITIUS_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: hkFundLiteratureDocsForNonCIFM
      }, {
        fundTypes: ["HK_UNIT_TRUST_PROVIDENT", "HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND", "HK_UNIT_TRUST_SAR", "MAURITIUS_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Fund Distribution Record", "pdp-documents-tab-fund-distribution-record-card-label"),
        cardTitleId: 'fundDistributionRecord',
        dataTest: 'fund-distribution-record',
        documents: hkFundDistributionDocs
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: hkFundLiteratureDocsForCIFM
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Financial Report", "pdp-documents-tab-financial-report-card-label"),
        cardTitleId: 'financialReport',
        dataTest: 'financial-report',
        documents: hkFinancialReportDocsForCIFM
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Fund Distribution Record", "pdp-documents-tab-fund-distribution-record-card-label"),
        cardTitleId: 'fundDistributionRecord',
        dataTest: 'fund-distribution-record',
        documents: [{ documentType: 'Income Distribution Rates' }]
      }],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, esgInformationCard],
      npsa: [{
        fundTypes: ["HK_UNIT_TRUST_PROVIDENT", "HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND", "HK_UNIT_TRUST_SAR", "MAURITIUS_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: hkFundLiteratureDocsForNonCIFM
      }, {
        fundTypes: ["HK_UNIT_TRUST_PROVIDENT", "HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND", "HK_UNIT_TRUST_SAR", "MAURITIUS_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Fund Distribution Record", "pdp-documents-tab-fund-distribution-record-card-label"),
        cardTitleId: 'fundDistributionRecord',
        dataTest: 'fund-distribution-record',
        documents: hkFundDistributionDocs
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: hkFundLiteratureDocsForCIFM
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Financial Report", "pdp-documents-tab-financial-report-card-label"),
        cardTitleId: 'financialReport',
        dataTest: 'financial-report',
        documents: hkFinancialReportDocsForCIFM
      }, {
        fundTypes: ["Mainland_HK_MRF_FUNDS"],
        cardTitle: _string_utility2.default.renderFormattedLabel("Fund Distribution Record", "pdp-documents-tab-fund-distribution-record-card-label"),
        cardTitleId: 'fundDistributionRecord',
        dataTest: 'fund-distribution-record',
        documents: [{ documentType: 'Income Distribution Rates' }]
      }]
    },
    ch: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      preview: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key  Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-jpmorgan-insights-label'),
        cardTitleId: 'insightsDocuments',
        dataTest: 'insights-documents',
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    no: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      preview: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (English)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=NO&lang=NO', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (English)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=NO&docCountry=NO', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    se: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      preview: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (English)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=SE&lang=SV', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (English)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=SV&docCountry=SE', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    dk: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      preview: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (English)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=DK&lang=DA', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (English)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=DA&docCountry=DK', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    fi: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: 'Factsheet (Finnish)',
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (Swedish)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=FI&lang=FI', 'country=SE&lang=SV') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: 'Key Information Document (Finnish)',
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (Swedish)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=FI&docCountry=FI', 'docLang=SV&docCountry=SE') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: 'Factsheet (Finnish)',
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (Swedish)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=FI&lang=FI', 'country=SE&lang=SV') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: 'Key Information Document (Finnish)',
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (Swedish)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=FI&docCountry=FI', 'docLang=SV&docCountry=SE') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      preview: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (English)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=FI&lang=FI', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (English)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=FI&docCountry=FI', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    au: {
      adv: [{
        fundTypes: ["AUSTRALIA_UNIT_TRUST", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Product Literature', 'pdp-documents-product-literature-label'),
        cardTitleId: 'productLiteratureDocuments',
        dataTest: 'product-literature-documents',
        documents: getAUUTProductLitConfig()
      }, {
        fundTypes: ["N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Documents', 'pdp-documents-supplemental-documents-label'),
        cardTitleId: 'supplementalDocuments',
        dataTest: 'supplemental-documents',
        documents: [{ documentType: TAG.ETF_SUPPLEMENT }, { documentType: TAG.DISTRIBUTION_SUPPLEMENT }]
      }, {
        fundTypes: ["AUSTRALIA_UNIT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Documents', 'pdp-documents-supplemental-documents-label'),
        cardTitleId: 'supplementalDocuments',
        dataTest: 'supplemental-documents',
        documents: [{ documentType: TAG.DISTRIBUTION_SUPPLEMENT }]
      }, {
        fundTypes: ["AUSTRALIA_UNIT_TRUST", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal Documents', 'pdp-documents-legal-documents-label'),
        cardTitleId: 'legalDocuments',
        dataTest: 'legal-documents',
        documents: getAUUTLegalDocumentsConfig()
      }, {
        fundTypes: ["AUSTRALIA_UNIT_TRUST", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('ESG Documents', 'pdp-documents-esg-documents-label'),
        cardTitleId: 'esgDocuments',
        dataTest: 'esg-documents',
        documents: getAUUTEsgDocumentsConfig()
      }],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label', { role: role }),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    sg: {
      per: [{
        fundTypes: ["HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label', { role: role }),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{ documentType: TAG.FACT_SHEET, languageOrders: ["en", "zh"] }, { documentType: TAG.COMMENTARY }, { documentType: TAG.PRODUCT_PRESENTATION }, { documentType: TAG.APAC_OFFERING_DOCUMENT }, { documentType: TAG.APAC_FINANCIAL_REPORT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: TAG.ANNUAL_REPORT }]
      }],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label', { role: role }),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    cn: {
      adv: [{
        fundTypes: ["HONG_KONG_UNIT_TRUST", "FT_LUX_FUND", "FT_LIQUIDITY_FUND"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label', { role: role }),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{ documentType: TAG.FACT_SHEET }, { documentType: TAG.COMMENTARY }]
      }]
    },
    de: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          documentType: 'Product Profiles'
        }, {
          documentType: 'Product Presentation'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }],
        disclosureId: 'pdpLegalDocCardDisclosureDe'
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }],
        disclosureId: 'pdpLegalDocCardDisclosureDe'
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: 'Factsheet (German)',
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (English)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=DE&lang=DE', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: 'Key Information Document (German)',
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (English)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=DE&docCountry=DE', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    at: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          documentType: 'Product Profiles'
        }, {
          documentType: 'Product Presentation'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }],
        disclosureId: 'pdpLegalDocCardDisclosureDe'
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }],
        disclosureId: 'pdpLegalDocCardDisclosureDe'
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet (German)', 'pdp-documents-fact-sheet-label-german'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (English)', 'pdp-documents-fact-sheet-label-english'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=AT&lang=DE', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (German)', 'pdp-documents-tab-fund-kiid-link-label-german'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (English)', 'pdp-documents-tab-fund-kiid-link-label-english'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=DE&docCountry=AT', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    fr: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }],
        disclosureId: 'pdpLegalDocCardDisclosureFr'
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }],
        disclosureId: 'pdpLegalDocCardDisclosureFr'
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: 'Factsheet (French)',
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (English)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=FR&lang=FR', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: 'Key Information Document (French)',
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (English)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=FR&docCountry=FR', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-jpmorgan-insights-label'),
        cardTitleId: 'insightsDocuments',
        dataTest: 'insights-documents',
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    nl: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: 'Factsheet (English)',
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=NL&lang=NL', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: 'Key Information Document (English)',
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=NL&docCountry=NL', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    lu: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-jpmorgan-insights-label'),
        cardTitleId: 'insightsDocuments',
        dataTest: 'insights-documents',
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      bony: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }]
      }],
      aifmd: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{ documentType: TAG.SALES_AID }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{ documentType: TAG.PRIIP_KID }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.PROSPECTUS_ANNOUNCEMENT }, { documentType: TAG.ANNUAL_REPORTS_AND_ACCOUNTS }, { documentType: TAG.ANNUAL_REPORT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: TAG.STATEMENT_ADDITIONAL_INFORMATION }, { documentType: TAG.LETTER_TO_SHAREHOLDERS }, { documentType: TAG.ARTICLES_OF_INCORPORATION }, { documentType: TAG.ANNUAL_GENERAL_MEETING }]
      }],
      ml: [!(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('EMEA_TECHRULES_FACTSHEET', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet (English)', 'pdp-documents-fact-sheet-label-english'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=LU', 'country=AR') : null,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (Spanish)', 'pdp-documents-fact-sheet-label-spanish'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=AR&lang=EN', 'country=AR&lang=ES') : null,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (Portuguese)', 'pdp-documents-fact-sheet-label-portuguese'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=AR&lang=EN', 'country=AR&lang=PT') : null,
          documentType: 'Share class factsheet'
        }]
      } : {}, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (English)', 'pdp-documents-tab-fund-kiid-link-label-english'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (Spanish)', 'pdp-documents-tab-fund-kiid-link-label-spanish'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=EN&docCountry=LU', 'docLang=ES&docCountry=ES') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      nra: [!(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('EMEA_TECHRULES_FACTSHEET', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet (English)', 'pdp-documents-fact-sheet-label-english'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=LU', 'country=AR') : null,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (Spanish)', 'pdp-documents-fact-sheet-label-spanish'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=AR&lang=EN', 'country=AR&lang=ES') : null,
          documentType: 'Share class factsheet'
        }]
      } : {}, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (English)', 'pdp-documents-tab-fund-kiid-link-label-english'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (Spanish)', 'pdp-documents-tab-fund-kiid-link-label-spanish'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=EN&docCountry=LU', 'docLang=ES&docCountry=ES') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    be: {
      adv: [!(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('EMEA_TECHRULES_FACTSHEET', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet (French)', 'pdp-documents-fact-sheet-label-french'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (Dutch)', 'pdp-documents-fact-sheet-label-dutch'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=BE&lang=FR', 'country=BE&lang=NL') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      } : {}, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (French)', 'pdp-documents-tab-fund-kiid-link-label-french'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (Dutch)', 'pdp-documents-tab-fund-kiid-link-label-dutch'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=FR&docCountry=BE', 'docLang=NL&docCountry=BE') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus', languageOrders: ["fr", "nl"] }, { documentType: 'Annual Report', languageOrders: ["fr", "nl"] }, { documentType: 'Semi-Annual Report', languageOrders: ["fr", "nl"] }, { documentType: 'ETF Supplement' }],
        disclosureId: "pdpLegalDocCardDisclosureEn"
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [!(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('EMEA_TECHRULES_FACTSHEET', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      } : {}, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }],
        disclosureId: "pdpLegalDocCardDisclosureFr"
      }, esgInformationCard],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet (French)', 'pdp-documents-fact-sheet-label-french'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (Dutch)', 'pdp-documents-fact-sheet-label-dutch'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=BE&lang=FR', 'country=BE&lang=NL') : null,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (English)', 'pdp-documents-fact-sheet-label-english'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=BE&lang=FR', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (French)', 'pdp-documents-tab-fund-kiid-link-label-french'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (Dutch)', 'pdp-documents-tab-fund-kiid-link-label-dutch'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=FR&docCountry=BE', 'docLang=NL&docCountry=BE') : null,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (English)', 'pdp-documents-tab-fund-kiid-link-label-english'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=FR&docCountry=BE', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    it: {
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet (Italian)', 'pdp-documents-fact-sheet-label-italian'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (English)', 'pdp-documents-fact-sheet-label-english'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=IT&lang=IT', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (Italian)', 'pdp-documents-tab-fund-kiid-link-label-italian'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (English)', 'pdp-documents-tab-fund-kiid-link-label-english'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=IT&docCountry=IT', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-jpmorgan-insights-label'),
        cardTitleId: 'insightsDocuments',
        dataTest: 'insights-documents',
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      mps: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }]
      }]
    },
    gb: {
      institutional: [{
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Reports and accounts', 'pdp-documents-reports-and-accounts-label'),
        cardTitleId: 'reportsAndAccountsDocuments',
        dataTest: 'reports-and-accounts-documents',
        sortByDateOrder: 'desc',
        columnIndex: 0,
        documents: [{ documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal Documents', 'pdp-documents-legal-documents-label'),
        cardTitleId: 'legalDocuments',
        dataTest: 'legal-documents',
        columnIndex: 0,
        documents: [{ documentType: 'Investor Disclosure Document' }, { documentType: 'Application form' }, { documentType: 'PRIIP KID' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Annual General Meeting and General / Class meeting', 'pdp-documents-agm-and-general-class-meeting-label'),
        cardTitleId: 'agmAndGeneralClassMeetingDocuments',
        dataTest: 'agm-and-general-class-meeting-documents',
        sortByDateOrder: 'desc',
        columnIndex: 0,
        documents: [{ documentType: "Articles of Incorporation" }, { documentType: 'MarketIs' }, { documentType: 'Annual General Meeting' }, { documentType: 'General Meeting Circular' }, { documentType: 'Class Meeting Final Proxy Voting Results' }, { documentType: 'General Meeting Final Proxy Voting Results' }]
      }, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-jpmorgan-insights-label'),
        cardTitleId: 'insightsDocuments',
        dataTest: 'insights-documents',
        columnIndex: 0,
        documents: getSingleInsightsConfig(intl, role)
      } : {}, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Trust information', 'pdp-documents-trust-information-label'),
        cardTitleId: 'trustInformationDocuments',
        dataTest: 'trust-information-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Factsheet'
        }, { documentType: 'Complete NAV Summary' }, { documentType: 'Prospectus' }, { documentType: 'Prospectus Announcement' }, { documentType: 'Sanctions Announcement' }, { documentType: 'LSE Announcement containing inside information' }, { documentType: 'AIFMD Remuneration Disclosure' }, { documentType: 'AIFMD Leverage and Remuneration Disclosure' }, { documentType: 'Shareholder Circular' }, { documentType: 'Letter to Shareholders' }, { documentType: 'Dividend Distributions' }, { documentType: 'Sub-division of Shares' }, { documentType: 'Discount Policy' }, { documentType: 'Special Resolution' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Committee terms of reference', 'pdp-documents-committee-terms-of-reference-label'),
        cardTitleId: 'committeeTermsOfReferenceDocuments',
        dataTest: 'committee-terms-of-reference-documents',
        columnIndex: 1,
        documents: [{ documentType: 'Board Membership Committee' }, { documentType: 'Audit Committee' }, { documentType: 'Risk Committee' }, { documentType: 'Audit and Risk Committee' }, { documentType: 'Nomination Committee' }, { documentType: 'Remuneration Committee' }, { documentType: 'Nomination and Remuneration Committee' }, { documentType: 'Management Engagement Committee' }, { documentType: 'Audit and Management Engagement Committee' }, { documentType: 'Policy on Non Audit Services' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Research', 'pdp-documents-research-label'),
        cardTitleId: 'researchDocuments',
        dataTest: 'research-documents',
        columnIndex: 1,
        documents: [{ documentType: 'Edison Investment Research' }, { documentType: 'Kepler Investment Research' }, { documentType: 'Marten & Co Investment Research' }, { documentType: 'Kepler Trust Intelligence' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Conversion details', 'pdp-documents-conversion-details-label'),
        cardTitleId: 'conversionDetailsDocuments',
        dataTest: 'conversion-details-documents',
        columnIndex: 1,
        documents: [{ documentType: 'Conversion details' }]
      }, {
        fundTypes: ["FT_LUX_FUND", "FT_LIQUIDITY_FUND", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        columnIndex: 0,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: ["FT_OEICS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        columnIndex: 0,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: ["FT_LUX_FUND", "FT_LIQUIDITY_FUND", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, {
        fundTypes: ["FT_OEICS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          documentType: 'KIID-OEIC'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }, { documentType: 'Information memorandum' }, { documentType: TAG.INVESTOR_DISCLOSURE_DOCUMENT }]
      }, isESGTabEnabled ? {} : {
        fundTypes: ["FT_LUX_FUND", "FT_LIQUIDITY_FUND", "N_ETF", "FT_OEICS", "INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('ESG Information', 'pdp-documents-esg-information-label'),
        cardTitleId: 'esgInformationDocuments',
        dataTest: 'esg-information-documents',
        columnIndex: 2,
        documents: [{ documentType: 'ESG Information' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Announcements', 'pdp-documents-announcements-details-label'),
        cardTitleId: 'announcementsDocuments',
        dataTest: 'announcements-documents',
        columnIndex: 2,
        documents: [{ documentType: 'Fund Announcement' }]
      }, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-jpmorgan-insights-label'),
        cardTitleId: 'insightsDocuments',
        dataTest: 'insights-documents',
        columnIndex: 2,
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      adv: [{
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Reports and accounts', 'pdp-documents-reports-and-accounts-label'),
        cardTitleId: 'reportsAndAccountsDocuments',
        dataTest: 'reports-and-accounts-documents',
        sortByDateOrder: 'desc',
        columnIndex: 0,
        documents: [{ documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }]
      }, {
        fundTypes: ["FT_LUX_FUND", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        columnIndex: 0,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        fundTypes: ["FT_OEICS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        columnIndex: 0,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { documentType: TAG.FUND_STORY }]
      }, {
        fundTypes: ["FT_LUX_FUND", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal Documents', 'pdp-documents-legal-documents-label'),
        cardTitleId: 'legalDocuments',
        dataTest: 'legal-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.ANNUAL_REPORT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: TAG.ETF_SUPPLEMENT }]
      }, {
        fundTypes: ["FT_OEICS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal Documents', 'pdp-documents-legal-documents-label'),
        cardTitleId: 'legalDocuments',
        dataTest: 'legal-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          documentType: 'KIID-OEIC'
        }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.ANNUAL_REPORT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: 'Information memorandum' }, { documentType: TAG.ETF_SUPPLEMENT }, { documentType: TAG.INVESTOR_DISCLOSURE_DOCUMENT }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal Documents', 'pdp-documents-legal-documents-label'),
        cardTitleId: 'legalDocuments',
        dataTest: 'legal-documents',
        columnIndex: 0,
        documents: [{ documentType: 'Investor Disclosure Document' }, { documentType: 'Application form' }, { documentType: 'LSE announcement' }, { documentType: 'PRIIP KID' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Trust information', 'pdp-documents-trust-information-label'),
        cardTitleId: 'trustInformationDocuments',
        dataTest: 'trust-information-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Factsheet'
        }, { documentType: TAG.COMPLETE_NAV_SUMMARY }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.PROSPECTUS_ANNOUNCEMENT }, { documentType: TAG.SANCTIONS_ANNOUNCEMENT }, { documentType: TAG.LSE_ANNOUNCEMENT_CONTAINING_INSIDE_INFORMATION }, { documentType: TAG.AIFMD_REMUNERATION_DISCLOSURE }, { documentType: TAG.AIFMD_LEVERAGE_AND_REMUNERATION_DISCLOSURE }, { documentType: TAG.SHAREHOLDER_CIRCULAR }, { documentType: TAG.LETTER_TO_SHAREHOLDERS }, { documentType: TAG.DIVIDEND_DISTRIBUTIONS }, { documentType: TAG.SUB_DIVISION_OF_SHARES }, { documentType: TAG.DISCOUNT_POLICY }, { documentType: TAG.SPECIAL_RESOLUTION }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Annual General Meeting and General / Class meeting', 'pdp-documents-agm-and-general-class-meeting-label'),
        cardTitleId: 'agmAndGeneralClassMeetingDocuments',
        dataTest: 'agm-and-general-class-meeting-documents',
        sortByDateOrder: 'desc',
        columnIndex: 0,
        documents: [{ documentType: "Articles of Incorporation" }, { documentType: 'Annual General Meeting' }, { documentType: 'General Meeting Circular' }, { documentType: 'Class Meeting Final Proxy Voting Results' }, { documentType: 'General Meeting Final Proxy Voting Results' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Committee terms of reference', 'pdp-documents-committee-terms-of-reference-label'),
        cardTitleId: 'committeeTermsOfReferenceDocuments',
        dataTest: 'committee-terms-of-reference-documents',
        columnIndex: 1,
        documents: [{ documentType: 'Board Membership Committee' }, { documentType: 'Audit Committee' }, { documentType: 'Risk Committee' }, { documentType: 'Audit and Risk Committee' }, { documentType: 'Nomination Committee' }, { documentType: 'Remuneration Committee' }, { documentType: 'Nomination and Remuneration Committee' }, { documentType: 'Management Engagement Committee' }, { documentType: 'Audit and Management Engagement Committee' }, { documentType: 'Policy on Non Audit Services' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Research', 'pdp-documents-research-label'),
        cardTitleId: 'researchDocuments',
        dataTest: 'research-documents',
        columnIndex: 1,
        documents: [{ documentType: 'Edison Investment Research' }, { documentType: 'Kepler Investment Research' }, { documentType: 'Marten & Co Investment Research' }, { documentType: 'Kepler Trust Intelligence' }],
        disclosureId: "pdpCardResearch"
      }, isESGTabEnabled ? {} : {
        fundTypes: ["FT_LUX_FUND", "N_ETF", "FT_OEICS", "INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('ESG Information', 'pdp-documents-esg-information-label'),
        cardTitleId: 'esgInformationDocuments',
        dataTest: 'esg-information-documents',
        columnIndex: 2,
        documents: [{ documentType: 'ESG Information' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Announcements', 'pdp-documents-announcements-details-label'),
        cardTitleId: 'announcementsDocuments',
        dataTest: 'announcements-documents',
        columnIndex: 2,
        documents: [{ documentType: 'Fund Announcement' }]
      }],
      per: [{
        fundTypes: ["FT_LUX_FUND", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        columnIndex: 0,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        fundTypes: ["FT_OEICS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        columnIndex: 0,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }]
      }, {
        fundTypes: ["FT_LUX_FUND", "N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal Documents', 'pdp-documents-legal-documents-label'),
        cardTitleId: 'legalDocuments',
        dataTest: 'legal-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.ANNUAL_REPORT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: TAG.ETF_SUPPLEMENT }]
      }, {
        fundTypes: ["FT_OEICS"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal Documents', 'pdp-documents-legal-documents-label'),
        cardTitleId: 'legalDocuments',
        dataTest: 'legal-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Investor Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          documentType: 'KIID-OEIC'
        }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.ANNUAL_REPORT }, { documentType: TAG.SEMI_ANNUAL_REPORT }, { documentType: 'Information memorandum' }, { documentType: TAG.ETF_SUPPLEMENT }, { documentType: TAG.INVESTOR_DISCLOSURE_DOCUMENT }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Reports and accounts', 'pdp-documents-reports-and-accounts-label'),
        cardTitleId: 'reportsAndAccountsDocuments',
        dataTest: 'reports-and-accounts-documents',
        sortByDateOrder: 'desc',
        columnIndex: 0,
        documents: [{ documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal Documents', 'pdp-documents-legal-documents-label'),
        cardTitleId: 'legalDocuments',
        dataTest: 'legal-documents',
        columnIndex: 0,
        documents: [{ documentType: TAG.INVESTOR_DISCLOSURE_DOCUMENT }, { documentType: TAG.APPLICATION_FORM }, { documentType: TAG.LSE_ANNOUNCEMENT }, { documentType: TAG.PRIIP_KID }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Trust information', 'pdp-documents-trust-information-label'),
        cardTitleId: 'trustInformationDocuments',
        dataTest: 'trust-information-documents',
        columnIndex: 1,
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Factsheet'
        }, { documentType: TAG.COMPLETE_NAV_SUMMARY }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.PROSPECTUS_ANNOUNCEMENT }, { documentType: TAG.SANCTIONS_ANNOUNCEMENT }, { documentType: TAG.LSE_ANNOUNCEMENT_CONTAINING_INSIDE_INFORMATION }, { documentType: TAG.AIFMD_REMUNERATION_DISCLOSURE }, { documentType: TAG.AIFMD_LEVERAGE_AND_REMUNERATION_DISCLOSURE }, { documentType: TAG.SHAREHOLDER_CIRCULAR }, { documentType: TAG.LETTER_TO_SHAREHOLDERS }, { documentType: TAG.DIVIDEND_DISTRIBUTIONS }, { documentType: TAG.SUB_DIVISION_OF_SHARES }, { documentType: TAG.DISCOUNT_POLICY }, { documentType: TAG.SPECIAL_RESOLUTION }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Annual General Meeting and General / Class meeting', 'pdp-documents-agm-and-general-class-meeting-label'),
        cardTitleId: 'agmAndGeneralClassMeetingDocuments',
        dataTest: 'agm-and-general-class-meeting-documents',
        sortByDateOrder: 'desc',
        columnIndex: 0,
        documents: [{ documentType: "Articles of Incorporation" }, { documentType: 'Annual General Meeting' }, { documentType: 'General Meeting Circular' }, { documentType: 'Class Meeting Final Proxy Voting Results' }, { documentType: 'General Meeting Final Proxy Voting Results' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Committee terms of reference', 'pdp-documents-committee-terms-of-reference-label'),
        cardTitleId: 'committeeTermsOfReferenceDocuments',
        dataTest: 'committee-terms-of-reference-documents',
        columnIndex: 1,
        documents: [{ documentType: 'Board Membership Committee' }, { documentType: 'Audit Committee' }, { documentType: 'Risk Committee' }, { documentType: 'Audit and Risk Committee' }, { documentType: 'Nomination Committee' }, { documentType: 'Remuneration Committee' }, { documentType: 'Nomination and Remuneration Committee' }, { documentType: 'Management Engagement Committee' }, { documentType: 'Audit and Management Engagement Committee' }, { documentType: 'Policy on Non Audit Services' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Research', 'pdp-documents-research-label'),
        cardTitleId: 'researchDocuments',
        dataTest: 'research-documents',
        columnIndex: 1,
        documents: [{ documentType: 'Edison Investment Research' }, { documentType: 'Kepler Investment Research' }, { documentType: 'Marten & Co Investment Research' }, { documentType: 'Kepler Trust Intelligence' }],
        disclosureId: "pdpCardResearch"
      }, isESGTabEnabled ? {} : {
        fundTypes: ["FT_LUX_FUND", "N_ETF", "FT_OEICS", "INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('ESG Information', 'pdp-documents-esg-information-label'),
        cardTitleId: 'esgInformationDocuments',
        dataTest: 'esg-information-documents',
        columnIndex: 2,
        documents: [{ documentType: 'ESG Information' }]
      }, {
        fundTypes: ["INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Announcements', 'pdp-documents-announcements-details-label'),
        cardTitleId: 'announcementsDocuments',
        dataTest: 'announcements-documents',
        columnIndex: 2,
        documents: [{ documentType: 'Fund Announcement' }]
      }]
    },
    jp: {
      per: [{
        fundTypes: ["JAPAN_INVESTMENT_TRUST"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        disclosureId: 'pdpCardDocument',
        documents: [{ documentType: TAG.SUMMARY_PROSPECTUS }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.FACT_SHEET }, { documentType: TAG.SUMMARY_ANNUAL_REPORT }, { documentType: TAG.ANNUAL_REPORT }, { documentType: TAG.CERTIFIED_HOLDINGS }]
      }, {
        fundTypes: ["N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        disclosureId: 'pdpCardDocument',
        documents: [{ documentType: TAG.FACT_SHEET }, { documentType: TAG.SUMMARY_PROSPECTUS, title: _string_utility2.default.renderFormattedLabel(TAG.SUMMARY_PROSPECTUS, 'pdp-etf-summary-prospectus-label'), docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/SP?site=JPMorganv3' }, { documentType: TAG.PROSPECTUS, title: _string_utility2.default.renderFormattedLabel(TAG.PROSPECTUS, 'pdp-etf-detail-prospectus-label'), docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/P?site=JPMorganv3' }, { documentType: TAG.ANNUAL_REPORT, title: _string_utility2.default.renderFormattedLabel(TAG.ANNUAL_REPORT, 'pdp-etf-annual-report-label'), docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/AR?site=JPMorganv3' }, { documentType: TAG.SEMI_ANNUAL_REPORT, title: _string_utility2.default.renderFormattedLabel(TAG.SEMI_ANNUAL_REPORT, 'pdp-etf-semi-annual-report-label'), docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/SAR?site=JPMorganv3' }, {
          documentType: TAG.ANNUAL_FINANCIAL_STATEMENTS_AND_OTHER_INFORMATION,
          title: _string_utility2.default.renderFormattedLabel(TAG.ANNUAL_FINANCIAL_STATEMENTS_AND_OTHER_INFORMATION, 'pdp-etf-doc-ncsr-label'),
          docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/NCSR?site=JPMorganv3'
        }, {
          documentType: TAG.SEMI_ANNUAL_FINANCIAL_STATEMENTS_AND_OTHER_INFORMATION,
          title: _string_utility2.default.renderFormattedLabel(TAG.SEMI_ANNUAL_FINANCIAL_STATEMENTS_AND_OTHER_INFORMATION, 'pdp-etf-doc-ncsrs-label'),
          docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/NCSRS?site=JPMorganv3'
        }, {
          documentType: TAG.FIRST_QUARTER_HOLDING,
          title: _string_utility2.default.renderFormattedLabel(TAG.FIRST_QUARTER_HOLDING, 'pdp-etf-doc-qh1-label'),
          docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/QH1?site=JPMorganv3'
        }, {
          documentType: TAG.THIRD_QUARTER_HOLDING,
          title: _string_utility2.default.renderFormattedLabel(TAG.THIRD_QUARTER_HOLDING, 'pdp-etf-doc-qh3-label'),
          docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/QH3?site=JPMorganv3'
        }, {
          documentType: TAG.STATEMENT_OF_ADDITIONAL_INFORMATION,
          title: _string_utility2.default.renderFormattedLabel(TAG.STATEMENT_OF_ADDITIONAL_INFORMATION, 'pdp-etf-doc-s-label'),
          docURL: 'https://am.jpmorgan.com/JPMorgan/TVT/`CUSIP`/S?site=JPMorganv3'
        }]
      }]
    },
    pt: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet (Portuguese)', 'pdp-documents-fact-sheet-label-portuguese'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (English)', 'pdp-documents-fact-sheet-label-english'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=PT&lang=PT', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (Portuguese)', 'pdp-documents-tab-fund-kiid-link-label-portuguese'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (English)', 'pdp-documents-tab-fund-kiid-link-label-english'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=PT&docCountry=PT', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    es: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard, !(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_SINGLE_INSIGHTS_CARD', visibleDataPoints) ? {
        cardTitle: _string_utility2.default.renderFormattedLabel('J.P. Morgan Insights', 'pdp-documents-tab-insights-card-label'),
        cardTitleId: 'insights',
        dataTest: "insights",
        documents: getSingleInsightsConfig(intl, role)
      } : {}],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet (Spanish)', 'pdp-documents-fact-sheet-label-spanish'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Factsheet (English)', 'pdp-documents-fact-sheet-label-english'),
          docURL: !(0, _ramda.isNil)(factsheetUrl) ? factsheetUrl.replace('country=ES&lang=ES', 'country=LU&lang=EN') : null,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (Spanish)', 'pdp-documents-tab-fund-kiid-link-label-spanish'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, {
          title: _string_utility2.default.renderFormattedLabel('Key Information Document (English)', 'pdp-documents-tab-fund-kiid-link-label-english'),
          docURL: !(0, _ramda.isNil)(kiidUrl) ? kiidUrl.replace('docLang=ES&docCountry=ES', 'docLang=EN&docCountry=LU') : null,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    tw: {
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label', { role: role }),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{ documentType: TAG.FACT_SHEET }, { documentType: TAG.PROSPECTUS }, { documentType: TAG.INVESTOR_DISCLOSURE_DOCUMENT }]
      }, esgInformationCard]
    },
    us: {
      adv: [{
        cardTitle: fundTypeCode === "SMA" ? _string_utility2.default.renderFormattedLabel('Strategy Literature', 'pdp-documents-fund-literature-label-sma') : _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, ["Commingled", "Tender Offer Fund"].includes(fundTypeCode) ? {} : {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{
          title: (0, _functional_utility.isNilOrEmpty)(fundName) ? '' : "Form N-MFP - " + fundName.replace('JPMorgan', ''),
          docURL: formNMFPLink
        }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS, replaceTextWithCusip: "[CUSIP]" }]
      }, fundTypeCode === "SMA" ? {} : {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints)
      }],
      per: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{
          title: (0, _functional_utility.isNilOrEmpty)(fundName) ? '' : "Form N-MFP - " + fundName.replace('JPMorgan', ''),
          docURL: formNMFPLink
        }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS, replaceTextWithCusip: "[CUSIP]" }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints)
      }],
      prl: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{
          title: (0, _functional_utility.isNilOrEmpty)(fundName) ? '' : "Form N-MFP - " + fundName.replace('JPMorgan', ''),
          docURL: formNMFPLink
        }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS, replaceTextWithCusip: "[CUSIP]" }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints)
      }],
      preview: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{
          title: (0, _functional_utility.isNilOrEmpty)(fundName) ? '' : "Form N-MFP - " + fundName.replace('JPMorgan', ''),
          docURL: formNMFPLink
        }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS, replaceTextWithCusip: "[CUSIP]" }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints)
      }],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{
          title: (0, _functional_utility.isNilOrEmpty)(fundName) ? '' : "Form N-MFP - " + fundName.replace('JPMorgan', ''),
          docURL: formNMFPLink
        }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: 'Summary Prospectus',
          docURL: (0, _url_utility.getDFSURL)(cusip, "SP", role),
          documentType: 'Summary Prospectus'
        }, {
          title: 'Prospectus',
          docURL: (0, _url_utility.getDFSURL)(cusip, "P", role),
          documentType: 'Prospectus'
        }, {
          title: 'Annual Report to Shareholders',
          docURL: (0, _url_utility.getDFSURL)(cusip, "AR", role),
          documentType: 'Annual Report'
        }, {
          title: 'Annual Financial Statements and Other Information',
          docURL: (0, _url_utility.getDFSURL)(cusip, "NCSR", role),
          documentType: 'Annual Financial Statements and Other Information'
        }, {
          title: 'Semi-Annual Report to Shareholders',
          docURL: (0, _url_utility.getDFSURL)(cusip, "SAR", role),
          documentType: 'Semi-Annual Report'
        }, {
          title: 'Semi-Annual Financial Statements and Other Information',
          docURL: (0, _url_utility.getDFSURL)(cusip, "NCSRS", role),
          documentType: 'Semi-Annual Financial Statements and Other Information'
        }, {
          title: 'Statement of Additional Information',
          docURL: (0, _url_utility.getDFSURL)(cusip, "S", role),
          documentType: 'Statement of Additional Information'
        }]
      }],
      ny529: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS }]
      }],
      bony: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{
          title: (0, _functional_utility.isNilOrEmpty)(fundName) ? '' : "Form N-MFP - " + fundName.replace('JPMorgan', ''),
          docURL: formNMFPLink
        }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: 'Summary Prospectus',
          docURL: (0, _url_utility.getDFSURL)(cusip, "SP", role),
          documentType: 'Summary Prospectus'
        }, {
          title: 'Prospectus',
          docURL: (0, _url_utility.getDFSURL)(cusip, "P", role),
          documentType: 'Prospectus'
        }, {
          title: 'Annual Report to Shareholders',
          docURL: (0, _url_utility.getDFSURL)(cusip, "AR", role),
          documentType: 'Annual Report'
        }, {
          title: 'Annual Financial Statements and Other Information',
          docURL: (0, _url_utility.getDFSURL)(cusip, "NCSR", role),
          documentType: 'Annual Financial Statements and Other Information'
        }, {
          title: 'Semi-Annual Report to Shareholders',
          docURL: (0, _url_utility.getDFSURL)(cusip, "SAR", role),
          documentType: 'Semi-Annual Report'
        }, {
          title: 'Semi-Annual Financial Statements and Other Information',
          docURL: (0, _url_utility.getDFSURL)(cusip, "NCSRS", role),
          documentType: 'Semi-Annual Financial Statements and Other Information'
        }, {
          title: 'Statement of Additional Information',
          docURL: (0, _url_utility.getDFSURL)(cusip, "S", role),
          documentType: 'Statement of Additional Information'
        }]
      }],
      accessfunds: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints)
      }],
      "6c": [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: 'Summary Prospectus',
          docURL: (0, _url_utility.getDFSURL)(cusip, "SP", role),
          documentType: 'Summary Prospectus'
        }, {
          title: 'Prospectus',
          docURL: (0, _url_utility.getDFSURL)(cusip, "P", role),
          documentType: 'Prospectus'
        }, {
          title: 'Annual Report to Shareholders',
          docURL: (0, _url_utility.getDFSURL)(cusip, "AR", role),
          documentType: 'Annual Report'
        }, {
          title: 'Semi-Annual Report to Shareholders',
          docURL: (0, _url_utility.getDFSURL)(cusip, "SAR", role),
          documentType: 'Semi-Annual Report'
        }, {
          title: 'Statement of Additional Information',
          docURL: (0, _url_utility.getDFSURL)(cusip, "S", role),
          documentType: 'Statement of Additional Information'
        }, {
          title: 'Proxy information',
          docURL: (0, _url_utility.getDFSURL)(cusip, "PVR", role),
          documentType: 'Proxy information'
        }, {
          title: 'Information Statement',
          docURL: (0, _url_utility.getDFSURL)(cusip, "IS", role),
          documentType: 'Information Statement'
        }]
      }],
      "xmobile": [{
        cardTitle: fundTypeCode === "SMA" ? _string_utility2.default.renderFormattedLabel('Strategy Literature', 'pdp-documents-fund-literature-label-sma') : _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        columnIndex: 0,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        columnIndex: 1,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS }]
      }, fundTypeCode === "SMA" ? {} : {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        columnIndex: 2,
        documents: getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints)
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Internal Use Only', 'pdp-documents-internal-use-only'),
        cardTitleId: 'internalUseOnlyDocuments',
        dataTest: 'internal-use-only-documents',
        columnIndex: 2,
        documents: [{ docCategory: TAG.INTERNAL_USE_ONLY }]
      }],
      institutional: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        leavingSiteOverlay: true,
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, fundTypeCode === "Commingled" ? {} : {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        leavingSiteOverlay: true,
        documents: [{
          title: (0, _functional_utility.isNilOrEmpty)(fundName) ? '' : "Form N-MFP - " + fundName.replace('JPMorgan', ''),
          docURL: formNMFPLink
        }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS, replaceTextWithCusip: "[CUSIP]" }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints)
      }]
    },
    ca: {
      adv: [{
        cardTitle: fundTypeCode === "SMA" ? _string_utility2.default.renderFormattedLabel('Strategy Literature', 'pdp-documents-fund-literature-label-sma') : _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS }]
      }, fundTypeCode === "SMA" ? {} : {
        cardTitle: _string_utility2.default.renderFormattedLabel('Legal documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: getCAETFRegulatoryDocuments(cusip, language, intl)
      }]
    },
    ie: {
      per: [{
        fundTypes: ["N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        fundTypes: ["N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      liq: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Account forms' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      adv: [{
        fundTypes: ["N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }]
      }, {
        fundTypes: ["N_ETF"],
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard],
      institutional: [{
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Factsheet', 'pdp-documents-fact-sheet-label'),
          docURL: factsheetUrl,
          documentType: 'Share class factsheet'
        }, { documentType: 'Exclusion Policy' }, { documentType: TAG.COMMENTARY }, { documentType: TAG.FUND_STORY }, { documentType: 'Sales Aid' }]
      }, {
        fundTypes: emeaInstitutionalFundTypes,
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: [{
          title: _string_utility2.default.renderFormattedLabel('Key Information Document', 'pdp-documents-tab-fund-kiid-link-label'),
          docURL: kiidUrl,
          documentType: 'Key Investor Information Document'
        }, { documentType: 'Prospectus' }, { documentType: 'Annual Report' }, { documentType: 'Semi-Annual Report' }, { documentType: 'ETF Supplement' }]
      }, esgInformationCard]
    },
    mx: {
      adv: [{
        cardTitle: _string_utility2.default.renderFormattedLabel('Fund Literature', 'pdp-documents-fund-literature-label'),
        cardTitleId: 'fundLiteratureDocuments',
        dataTest: 'fund-literature-documents',
        documents: [{ docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_FUND_LITERATURE }, { docCategory: TAG.US_FUND_LITERATURE }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-documents-supplemental-information'),
        cardTitleId: 'supplementalInformationDocuments',
        dataTest: 'supplemental-information-documents',
        documents: [{
          title: (0, _functional_utility.isNilOrEmpty)(fundName) ? '' : "Form N-MFP - " + fundName.replace('JPMorgan', ''),
          docURL: formNMFPLink
        }, { docCategory: TAG.PRODUCT_DOCUMENTS, documentType: TAG.US_SUPPLEMENTAL_DOCUMENTS }, { docCategory: TAG.US_SUPPLEMENTAL_DOCUMENTS, replaceTextWithCusip: "[CUSIP]" }]
      }, {
        cardTitle: _string_utility2.default.renderFormattedLabel('Regulatory Documents', 'pdp-documents-regulatory-documents-label'),
        cardTitleId: 'regulatoryDocuments',
        dataTest: 'regulatory-documents',
        documents: getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints)
      }]
    }
  };
  if ((0, _functional_utility.isNilOrEmpty)(fundDocumentTabConfig[country])) {
    return null;
  }
  return fundDocumentTabConfig[country][role];
};

var getInsightsConfig = function getInsightsConfig() {
  return [{
    title: 'Market Insights',
    docURL: 'https://am.jpmorgan.com/gb/en/asset-management/gim/adv/insights/market-insights'
  }, {
    title: 'Portfolio Insights',
    docURL: 'https://am.jpmorgan.com/gb/en/asset-management/gim/adv/insights/portfolio-insights'
  }];
};

var getSingleInsightsConfig = function getSingleInsightsConfig(intl, role) {
  return [{
    title: _string_utility2.default.renderFormattedLabel('Insights', 'pdp-documents-tab-insights-link-label'),
    docURL: intl.formatMessage({
      id: "pdp-documents-insights-" + role + "-url",
      defaultMessage: "https://am.jpmorgan.com/gb/en/asset-management/gim/adv/insights/market-insights"
    })
  }];
};

var getAUUTProductLitConfig = function getAUUTProductLitConfig() {
  return [{ documentType: TAG.FACT_SHEET }, { documentType: TAG.COMMENTARY }, { documentType: TAG.BROCHURE }, { documentType: TAG.FUND_STORY }];
};

var getAUUTLegalDocumentsConfig = function getAUUTLegalDocumentsConfig() {
  return [{ documentType: TAG.AU_PRODUCT_DISCLOSURE_STATEMENT }, { documentType: TAG.INVESTOR_DISCLOSURE_DOCUMENT }, { documentType: TAG.AU_TARGET_MARKET_DETERMINATION }, { documentType: TAG.AU_REFERENCE_GUIDE }, { documentType: TAG.APAC_FINANCIAL_REPORT }, { documentType: TAG.AU_ACCOUNT_FORMS }, { documentType: TAG.AU_STATEMENT_ADDITIONAL_INFORMATION }, { documentType: TAG.AU_WITHDRAWL_FORM }, { documentType: TAG.SEMI_ANNUAL_REPORT }];
};

var getAUUTEsgDocumentsConfig = function getAUUTEsgDocumentsConfig() {
  return [{ documentType: TAG.ESG_INFORMATION }];
};

var getRegulatoryDocuments = function getRegulatoryDocuments(fundTypeCode, cusip, role, visibleDataPoints) {

  var regulatoryDocuments = [{
    title: 'Summary Prospectus',
    docURL: (0, _url_utility.getDFSURL)(cusip, "SP", role),
    documentType: 'Summary Prospectus'
  }, {
    title: 'Prospectus',
    docURL: (0, _url_utility.getDFSURL)(cusip, "P", role),
    documentType: 'Prospectus'
  }, {
    title: 'Annual Report to Shareholders',
    docURL: (0, _url_utility.getDFSURL)(cusip, "AR", role),
    documentType: 'Annual Report'
  }, {
    title: 'Annual Financial Statements and Other Information',
    docURL: (0, _url_utility.getDFSURL)(cusip, "NCSR", role),
    documentType: 'Annual Financial Statements and Other Information'
  }, {
    title: 'Semi-Annual Report to Shareholders',
    docURL: (0, _url_utility.getDFSURL)(cusip, "SAR", role),
    documentType: 'Semi-Annual Report'
  }, {
    title: 'Semi-Annual Financial Statements and Other Information',
    docURL: (0, _url_utility.getDFSURL)(cusip, "NCSRS", role),
    documentType: 'Semi-Annual Financial Statements and Other Information'
  }];

  if (!(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_FIRST_THIRD_QUARTER_HOLDING_DOCUMENT', visibleDataPoints)) {
    regulatoryDocuments.push({
      title: 'First Quarter Holding',
      docURL: (0, _url_utility.getDFSURL)(cusip, "QH1", role),
      documentType: 'First Quarter Holding'
    }, {
      title: 'Third Quarter Holding',
      docURL: (0, _url_utility.getDFSURL)(cusip, "QH3", role),
      documentType: 'Third Quarter Holding'
    });
  } else if (!(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_ONLY_PROSPECTUS_DOCUMENT', visibleDataPoints)) {
    return [{
      title: 'Prospectus',
      docURL: (0, _url_utility.getDFSURL)(cusip, "P", role),
      documentType: 'Prospectus'
    }];
  }

  regulatoryDocuments.push({
    title: 'Statement of Additional Information',
    docURL: (0, _url_utility.getDFSURL)(cusip, "S", role),
    documentType: 'Statement of Additional Information'
  });

  if (fundTypeCode === "Commingled") {
    regulatoryDocuments = (0, _url_utility.getCommingledRegulatoryDocumentLinks)(cusip, role);
    regulatoryDocuments.push({ documentType: TAG.DOT_APPENDIX });
  } else if (fundTypeCode === "529 Plans") {
    return null;
  }

  if (!(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('SHOW_ANNUAL_REPORT_OF_PROXY_VOTING_REPORT', visibleDataPoints)) {
    regulatoryDocuments.push({
      title: 'Annual Report Of Proxy Voting',
      docURL: (0, _url_utility.getDFSURL)(cusip, "NPX", role),
      documentType: 'Annual Report Of Proxy Voting'
    });
  }

  if (!(0, _ramda.isNil)(visibleDataPoints) && (0, _ramda.includes)('HIDE_SUMMARY_PROSPECTUS_DOCUMENT', visibleDataPoints)) {
    return regulatoryDocuments.filter(function (doc) {
      return doc.documentType !== TAG.SUMMARY_PROSPECTUS;
    });
  }
  return regulatoryDocuments;
};

var getCAETFRegulatoryDocuments = function getCAETFRegulatoryDocuments(cusip, language, intl) {
  var mapDocObj = function mapDocObj(category) {
    var docType = intl.formatMessage({
      id: "pdp-etf-doc-label-" + category,
      defaultMessage: ""
    });
    return {
      title: docType,
      docURL: (0, _url_utility.getCADFSURL)(cusip, language, category),
      documentType: docType
    };
  };
  return ["AR", "SAR", "PR", "FSD", "IS", "P", "FS", "QR"].map(mapDocObj);
};

exports.getFundDocumentConfig = getFundDocumentConfig;
exports.getInsightsConfig = getInsightsConfig;
exports.getSingleInsightsConfig = getSingleInsightsConfig;
exports.getFundDocumentTabConfig = getFundDocumentTabConfig;
exports.getRegulatoryDocuments = getRegulatoryDocuments;